export class RectSize
{
    private _size: number;
    private _width: number;
    private _height: number;

    public get size(): number { return this._size; }
    public set size(value: number) { this._size = this._width = this._height = value; }
    public get width(): number { return this._width; }
    public set width(value: number) { this._width = value; }
    public get height(): number { return this._height; }
    public set height(value: number) { this._height = value; }

    public constructor();
    public constructor(size: number);
    public constructor(width: number, height: number);
    public constructor(a: number = undefined, b: number = undefined)
    {
        this.Set(a, b);
    }

    public Set?(): void;
    public Set?(size: number): void;
    public Set?(width: number, height: number): void;
    public Set?(a: number = undefined, b: number = undefined): void
    {
        {
            if (b == undefined) {
                if (a == undefined) {
                    this._size = 
                    this._width =
                    this._height = 0;
                }
                else {
                    this._size = 
                    this._width =
                    this._height = a;
                }
            }
            else {
                this._size = (a + b) / 2;
                this._width = a;
                this._height = b;
            }
        }
    }

    public CopyFrom(anotherRectSize: RectSize): void
    {
        this.Set(anotherRectSize.size);
    }
}